module.exports = __webpack_public_path__ + "assets/img/myhome_tittle.d982deb9.svg";